import {
  Component,
  Input,
  AfterViewInit,
  ElementRef,
  OnChanges
} from '@angular/core';

import { Grid } from '../../../lib/grid';

@Component({
    selector: '[ng2-st-actions-title]',
    template: ` <div class='ng2-smart-title'>{{ actionsColumnTitle }}</div> `,
    standalone: false
})
export class ActionsTitleComponent implements AfterViewInit, OnChanges {
  @Input() public grid: Grid;

  public actionsColumnTitle: string;

  constructor(private ref: ElementRef) {}

  public ngAfterViewInit() {
    this.ref.nativeElement.classList.add('ng2-smart-actions');
  }

  public ngOnChanges() {
    this.actionsColumnTitle = this.grid.getSetting('actions.columnTitle');
  }
}
